var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNotificationDataAnalysisComplete = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#00D2A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5717 15.715L16.5928 7.64395C17.1859 6.84888 18.4024 7.28888 18.4024 8.29849V13.1835C18.4024 13.77 18.8556 14.2455 19.4147 14.2455H21.3863C22.2302 14.2455 22.7036 15.2649 22.1836 15.9621L16.1625 24.0331C15.5694 24.8282 14.3529 24.3882 14.3529 23.3786V18.4936C14.3529 17.9071 13.8997 17.4316 13.3406 17.4316H11.369C10.5251 17.4316 10.0517 16.4122 10.5717 15.715Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNotificationDataAnalysisComplete);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/notification_data_analysis_complete.20a6e6a79955f43545db27a2a33e5306.svg";